export default __webpack_public_path__ + "static/media/partnersBackground.2dde1a1d.png";